import gql from 'graphql-tag';

export default gql`
mutation changeAppReview(
        $uuid: String!,
        $promoted: Boolean,
        $completed: Boolean
        ) {
    updateApps(input: {
        uuid: $uuid,
        promoted: $promoted,
        completed: $completed
    }) {
        uuid
    }
}
`;
